globalThis.regeneratorRuntime = undefined;

import 'regenerator-runtime/runtime';

import setupWalkme from '@avalara/bat-apps-shared/server/walkme';
import { SContainer } from '@avalara/skylab-sdk/react';
import { configureStore } from '@reduxjs/toolkit';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import thunk from 'redux-thunk';

import App from './containers/app';
import { isOneWebDomainRuntime } from './helpers/index';
import reducer, { defaultState } from './reducers';
import '../../public/main.css';

import IntlProviderWrapper from './providers/IntlProviderWrapper';

const { appEnv, __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

// window.appEnv *should* always have a value, but if somehow it doesn't
// default to using the prod walkme script
setupWalkme(appEnv ?? 'prod');

const store = configureStore({
  reducer,
  preloadedState: defaultState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  devTools: appEnv !== 'prod' && !!__REDUX_DEVTOOLS_EXTENSION_COMPOSE__,
});

const root = isOneWebDomainRuntime() ? document.querySelector('main') : document.getElementById('react-root');

if (root && isOneWebDomainRuntime()) {
  ReactDOM.createRoot(root).render(
    <IntlProviderWrapper>
      <Provider store={store}>
        <BrowserRouter basename='/buy'>
          <SContainer>
            <App />
          </SContainer>
        </BrowserRouter>
      </Provider>
    </IntlProviderWrapper>,
  );
} else if (root) {
  ReactDOM.createRoot(root).render(
    <IntlProviderWrapper>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </IntlProviderWrapper>,
  );
}
